import { useContext } from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import NvSwitch from 'shared/components/inputs/nv-switch';
import { NvTooltip } from 'shared/components/nv-tooltip';
import { useAppDispatch } from 'redux/store';
import { SaveStatus } from 'redux/schemas/app/mentoring-programs';
import { setSaveStatus, updateMentoringProgram } from 'redux/actions/mentoring-programs';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import { wrapThunkAction } from 'redux/utils';
import { RootState } from 'redux/schemas';
import { config } from '@config/pendo.config.json';
import MentoringProgramContext from '../../context';

const MenteeLens = () => {
  const dispatch = useAppDispatch();
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { aiMeetingPrepEnabled } = mentoringProgram || {};
  const aliases = useSelector((state: RootState) => getMentoringProgramAliases(state, mentoringProgram?.id));
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.MENTEE_LENS;

  const label = aiMeetingPrepEnabled
    ? translationBase.ARIA_LABEL.TURN_OFF({ menteeTitleAlias: aliases.MenteeTitleAlias ?? '' })
    : translationBase.ARIA_LABEL.TURN_ON({ menteeTitleAlias: aliases.MenteeTitleAlias ?? '' });

  const handleChange = () => {
    dispatch(setSaveStatus({ newStatus: SaveStatus.IN_PROGRESS }));
    wrapThunkAction(
      dispatch(
        updateMentoringProgram({
          id: mentoringProgram.id,
          autoMatchingEnabled: !!mentoringProgram.autoMatchingEnabled,
          maxMentees: mentoringProgram.concurrentMentorConnection,
          aiMeetingPrepEnabled: !aiMeetingPrepEnabled,
        }),
      ),
    ).then(() => {
      dispatch(setSaveStatus({ newStatus: SaveStatus.COMPLETED }));
    }).finally(() => {
      setTimeout(() => {
        dispatch(setSaveStatus({ newStatus: null }));
      }, 3000);
    });
  };

  return (
    <div className='mb-2'>
      <div className='d-flex mb-2 align-items-center'>
        <div className='heading-5 mr-2'>
          {translationBase.SWITCH_LABEL({ menteeTitleAlias: aliases.MenteeTitleAlias ?? '' })}
        </div>
        <NvTooltip placement='top' preventOverflow={false} text={label}>
          <NvSwitch
            checked={aiMeetingPrepEnabled}
            onChange={handleChange}
            enabledLabel={t.SHARED.ON().toUpperCase()}
            disabledLabel={t.SHARED.OFF().toUpperCase()}
            dataQa={config.pendo.athena.mentorshipProgram.settings.guidance.menteeLensSwitch}
            aria-label={label}
          />
        </NvTooltip>
      </div>
      <div className='text-body black'>
        {translationBase.DESCRIPTION({
          mentorsAlias: aliases.mentorsAlias ?? '',
          menteeAlias: aliases.menteeAlias ?? '',
        })}
      </div>
    </div>
  );
};

export default MenteeLens;
